import { CircularProgress } from '@civilgrid/ui/components';
import { useMemo } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { useAsyncRetry } from 'react-use';
import { getCivilSearchers } from '~/api/civilsearch';
import ControlledSelect from '~/components2/forms/controlled/ControlledSelect';
import type { Item } from '~/components2/forms/Select';

export type PFormValues = {
  assignedTo: string;
};

interface AdminProps {
  form: UseFormReturn<PFormValues, any>;
  projectId: string;
}

export default function AdminSelect({ form, projectId }: AdminProps) {
  const civilSearchers = useAsyncRetry(() => getCivilSearchers(), [projectId]);

  const civilSearcherItems = useMemo<Item[]>(() => {
    if (!civilSearchers.value) return [];

    return civilSearchers.value.map((searcher) => ({
      value: searcher.userId,
      label: (
        <div>
          <div className="">{searcher.name}</div>
          <div className="text-xs">{searcher.email}</div>
        </div>
      ),
      keywords: [searcher.email, searcher.name],
    }));
  }, [civilSearchers]);

  if (civilSearchers.loading) return <CircularProgress indeterminate />;

  if (civilSearchers.error || !civilSearchers.value) {
    return <div>An error occurred fetching civil searchers</div>;
  }

  return (
    <ControlledSelect
      control={form.control}
      name="assignedTo"
      label="Assign Requests To"
      items={civilSearcherItems}
      isRequired={false}
      tooltipText="The civil searcher this request is assigned to"
    />
  );
}
